module.exports = __webpack_public_path__ + "img/2.d366cd84.jpg";